export * from 'depreciations/selectors/depreciations_selectors';



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/selectors/index.js